import { createActions } from 'redux-actions'

import { createFormActions, identityAction } from '../../utils/actions'

export const {
  auth: {
    show: showAuth,
    close: closeAuth,
    login,
    loginSuccess,
    loginFailure,
    logout,
    logoutSuccess,
    logoutFailure,
    register,
    registerSuccess,
    registerFailure,
    reset,
    resetSuccess,
    resetFailure,
    showResetForm,
    showRegisterForm
  }
} = createActions({
  AUTH: {
    SHOW: identityAction,
    CLOSE: identityAction,
    SHOW_RESET_FORM: identityAction,
    SHOW_REGISTER_FORM: identityAction,
    ...createFormActions('LOGIN'),
    ...createFormActions('LOGOUT'),
    ...createFormActions('REGISTER'),
    ...createFormActions('RESET')
  }
})
